import script from "./JaContentImageResize.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentImageResize.vue?vue&type=script&setup=true&lang=js"

import "./JaContentImageResize.vue?vue&type=style&index=0&id=af8e28ac&lang=css"
import "./JaContentImageResize.vue?vue&type=style&index=1&id=af8e28ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af8e28ac"]])

export default __exports__